export default [
  {
    title: "Report",
    customIcon: "ReportSVG",
    children: [
      {
        title: "Report List",
        route: "report",
        path: "/report",
      },
    ],
  },
];
